import WebsiteCoinsImage from '@page-components/CheckoutV3/sections/WebsiteCoins/WebsiteCoinsCount/WebsiteCoinsImage'
import Link from 'next/link'

import useWebsiteCoinsBalanceNavBar from './useWebsiteCoinsBalanceNavBar.main'

export default function WebsiteCoin({websiteId, config}) {
  const {me} = useWebsiteCoinsBalanceNavBar(websiteId)

  if (!me?.websiteCoinsBalance && me?.websiteCoinsBalance !== 0) return null

  return (
    <div className="flex bg-red-600 py-5 px-7 rounded-md text-white justify-center">
      <WebsiteCoinsImage />
      <Link href="/justoloyalty" passHref>
        <span className="font-bold text-lg ml-2 text-white cursor-pointer">
          Tienes {me.websiteCoinsBalance} {config.name}
        </span>
      </Link>
    </div>
  )
}
